import { Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import {NgClass, NgIf} from '@angular/common';
import { HeaderComponent } from './core/components/header/header.component';
import { NotificationsComponent } from './core/components/notifications/notifications.component';
import { AuthService } from './core/services/auth.service';
import { environment } from '../environments/environment';

@Component({
    selector: 'app-root',
    standalone: true,
    imports: [RouterOutlet, NgIf, HeaderComponent, NotificationsComponent, NgClass],
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
    isStaging = environment.isStaging;

    constructor(public authService: AuthService) {}

    ngOnInit() {}
}
